// Interfaces
import { IWriteOffPreviewFilter } from "../interfaces";
import { ICitActivity } from "@/Common/types/ContractsInTransit/model";

// MUI
import { Box, Grid, Stack, Typography } from "@mui/material";

// Layouts
import EmptyBody from "@/Layouts/components/Basics/EmptyBody";
import TableLoader from "@/Layouts/components/Skeletons/TableLoader";

// Components
import CitActivitiesTable from "@/DataPages/components/FniManagement/components/CIT/Tables/CitActivitiesTable";

// Images
import emptyTable from "@/assets/images/commons/empty_table.png";

interface ICitModelTableProps {
	title: string;
	hierarchyKey: string;
	activities: ICitActivity[];
	disabled: boolean;
	isShowing?: boolean;
	isLoading: boolean;
	isFetching: boolean;
	activitiesIds?: string[];
	filter?: IWriteOffPreviewFilter;
	onUpdateAction: (value: string[]) => void;
}

export default function CitActivitiesTableModel(props: Readonly<ICitModelTableProps>) {
	const {
		filter,
		hierarchyKey,
		isShowing,
		title = "Finance Reserves",
		activities = [],
		activitiesIds = [],
		disabled = false,
		isLoading = false,
		onUpdateAction = () => {},
	} = props ?? {};

	const dataToShow = Boolean(activities?.length);

	if (isLoading) {
		return (
			<Grid item xs={12} mt={1}>
				<TableLoader toolbar buttons={3} content rows={5} multiTitles={5} />
			</Grid>
		);
	}

	const handleUpdateActivities = (activitiesIds: string[]) => {
		onUpdateAction(activitiesIds);
	};

	return (
		<Grid container alignContent="flex-start" className="h-full">
			<Grid container item>
				<Grid item xs={12} height={465}>
					{!dataToShow ? (
						<EmptyBody image={emptyTable} title={`No ${title} to show`} bodyHeight={"435px"} className="!shadow-none" />
					) : (
						<Stack className="h-full">
							<Stack className="h-full">
								<CitActivitiesTable
									title={title}
									filter={filter}
									selectedActivities={activitiesIds}
									activities={activities}
									hierarchy={hierarchyKey}
									disabled={disabled}
									isShowing={isShowing}
									onUpdateAction={handleUpdateActivities}
								/>
							</Stack>
							<Stack mt={1} justifyContent={"center"} alignItems={"end"}>
								<Stack alignItems={"start"} spacing={0.5}>
									<Box className={"flex flex-row items-center"}>
										<Box className="bg-success w-[5px] h-[16px] mr-[8px]" />
										<Typography className={"regular-pt-sans-pro-narrow-label"} component={"span"}>
											Recommended for cleaning schedule journal entry
										</Typography>
									</Box>
									<Box className={"flex flex-row items-center"}>
										<Box className="bg-dark-yellow w-[5px] h-[16px] mr-[8px]" />
										<Typography className={"regular-pt-sans-pro-narrow-label"} component={"span"}>
											Consider reviewing, becoming aged
										</Typography>
									</Box>
								</Stack>
							</Stack>
						</Stack>
					)}
				</Grid>
			</Grid>
		</Grid>
	);
}
